import apisauce from 'apisauce'

const create = (baseURL = 'https://api.dealmachine.com/') => {
  const api = apisauce.create({
    baseURL,
    headers: {
      // Here if necessary
    },
    timeout: 40000
  })

  const signup = (email, password, firstname, lastname, team_id, from_campaign, from_source, branch_id, signupKey) => api.post('v1/login/', {
    email: email,
    password: password,
    firstname: firstname,
    lastname: lastname,
    team_id: team_id,
    from_campaign: from_campaign,
    from_source: from_source,
    signupKey: signupKey,
    branch_id: branch_id,
    device: "desktop",
    user_version: 2
  });

  const getUser = (token) => api.get('v1/user/', {
    token: token
  });


  const teamInfo = ({id}) => api.get('legacy/team-info/',{
    id
  });

  const textLink = (token, phone_number, text) => api.post('private/text-link/', {
    token: token,
    phone_number: phone_number,
    text: text
  });

  return {
    signup,
    getUser,
    teamInfo,
    textLink
  }
}

export default {
  create
}



// WEBPACK FOOTER //
// ./src/actions/API.js